/**
 * Dynamic Title Update for Carat and Metal Selection
 * This version uses Dawn's internal 'variant-change' event for instant updates.
 */

/**
 * Dynamic Title Update for Carat and Metal Selection
 * This version uses the URL Variant ID as the absolute source of truth.
 * It fetches the product data directly to ensure zero-refresh accuracy.
 */
(function () {
    let isProcessing = false;
    let productData = null;

    async function fetchProductData() {
        if (productData) return productData;
        try {
            const handle = window.location.pathname.split('/').pop();
            const response = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
            productData = await response.json();
            return productData;
        } catch (e) {
            console.error('Failed to fetch product data', e);
            return null;
        }
    }

    async function updateTitleUI() {
        if (isProcessing) return;

        // 1. Get current variant ID from URL or hidden input
        const urlParams = new URLSearchParams(window.location.search);
        let variantId = urlParams.get('variant');
        if (!variantId) {
            const idInput = document.querySelector('input[name="id"]');
            if (idInput) variantId = idInput.value;
        }
        if (!variantId) return;

        isProcessing = true;

        // 2. Ensure we have product data
        const data = await fetchProductData();
        if (!data) {
            isProcessing = false;
            return;
        }

        // 3. Find the variant
        const variant = data.variants.find(v => v.id == variantId);
        if (!variant) {
            isProcessing = false;
            return;
        }

        // 4. Identify Carat, Metal and Shape values
        let caratVal = '';
        let metalVal = '';
        let shapeVal = '';

        data.options.forEach((opt, idx) => {
            const name = opt.name.toLowerCase();
            if (name.includes('carat')) {
                caratVal = variant.options[idx];
            } else if (name.includes('metal')) {
                metalVal = variant.options[idx];
            } else if (name.includes('shape')) {
                shapeVal = variant.options[idx];
            }
        });

        // 4.1 Fallback for Shape detection from title if not in options
        if (!shapeVal) {
            const shapes = ['Round', 'Oval', 'Pear', 'Cushion', 'Emerald', 'Radiant', 'Princess', 'Asscher', 'Marquise', 'Heart'];
            shapes.forEach(s => {
                if (data.title.includes(s)) shapeVal = s;
            });
        }

        // 5. Update the spans in the title
        const caratSpans = document.querySelectorAll('.js-carat-display');
        const metalSpans = document.querySelectorAll('.js-metal-display');

        if (caratVal) {
            caratSpans.forEach(span => {
                if (span.innerText !== caratVal) {
                    span.innerText = caratVal;
                }
            });
        }

        if (metalVal) {
            const displayMetal = metalVal.replace(/Solid/i, '').replace(/\s+/g, ' ').trim();
            const metalText = ' in ' + displayMetal;
            metalSpans.forEach(span => {
                if (span.innerText !== metalText) {
                    span.innerText = metalText;
                }
            });
        }

        // 6. Update Product Specs Table
        const specsShape = document.getElementById('Specs-Shape');
        const specsCarat = document.getElementById('Specs-Carat');
        const specsColorClarity = document.getElementById('Specs-Color-Clarity');
        const specsMetalPurity = document.getElementById('Specs-Metal-Purity');
        const specsMetalTone = document.getElementById('Specs-Metal-Tone');

        if (specsShape && shapeVal) specsShape.innerText = shapeVal;
        if (specsCarat && caratVal) specsCarat.innerText = caratVal;

        if (specsMetalPurity && metalVal) {
            let purity = '';
            if (metalVal.includes('10')) purity = '10KT Solid Gold';
            else if (metalVal.includes('14')) purity = '14KT Solid Gold';
            else if (metalVal.includes('18')) purity = '18KT Solid Gold';
            else if (metalVal.includes('Platinum') || metalVal.includes('PT')) purity = '950 Platinum';
            else if (metalVal.includes('Silver')) purity = '925 Silver';
            
            if (purity) specsMetalPurity.innerText = purity;
        }

        if (specsMetalTone && metalVal) {
            const lowMetal = metalVal.toLowerCase();
            let tone = '';
            if (lowMetal.includes('white') || lowMetal.includes('platinum') || lowMetal.includes('pt') || lowMetal.includes('silver')) tone = 'White';
            else if (lowMetal.includes('yellow')) tone = 'Yellow';
            else if (lowMetal.includes('rose')) tone = 'Rose';
            
            if (tone) specsMetalTone.innerText = tone;
        }

        if (specsColorClarity) {
            let colorClarityVal = '';
            const titleDC = data.title.toLowerCase();
            const typeDC = (data.type || '').toLowerCase();
            
            if (titleDC.includes('lab diamond') || titleDC.includes('lab grown') || typeDC.includes('lab diamond') || typeDC.includes('lab grown')) {
                colorClarityVal = 'EF-VS1';
            } else if (titleDC.includes('moissanite') || typeDC.includes('moissanite')) {
                colorClarityVal = 'EF-VVS';
            }

            if (colorClarityVal) {
                specsColorClarity.innerText = colorClarityVal;
            }
        }

        const specsType = document.getElementById('Specs-Type');
        const typeSpans = document.querySelectorAll('.js-type-display');
        
        let typeVal = '';
        const titleDC = data.title.toLowerCase();
        const typeDC = (data.type || '').toLowerCase();
        
        if (titleDC.includes('lab diamond') || titleDC.includes('lab grown') || typeDC.includes('lab diamond') || typeDC.includes('lab grown')) {
            typeVal = 'Lab Grown Diamond';
        } else if (titleDC.includes('moissanite') || typeDC.includes('moissanite')) {
            typeVal = 'Moissanite';
        }

        if (typeVal) {
            if (specsType) specsType.innerText = typeVal;
            typeSpans.forEach(span => {
                if (span.innerText !== typeVal) {
                    span.innerText = typeVal;
                }
            });
        }

        setTimeout(() => { isProcessing = false; }, 100);
    }

    // Hook into URL changes (Dawn updates URL on variant change)
    const originalPushState = history.pushState;
    history.pushState = function () {
        originalPushState.apply(this, arguments);
        updateTitleUI();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function () {
        originalReplaceState.apply(this, arguments);
        updateTitleUI();
    };

    // Dawn AJAX re-rendering detection
    const observer = new MutationObserver((mutations) => {
        updateTitleUI();
    });

    const target = document.querySelector('.product__info-container') || document.body;
    observer.observe(target, { childList: true, subtree: true });

    // Initial Run
    updateTitleUI();

    // High-frequency check during initial load
    let checkCount = 0;
    const initTimer = setInterval(() => {
        updateTitleUI();
        if (++checkCount > 10) clearInterval(initTimer);
    }, 500);

})();
